import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const ExportBtnPages = (state = initialState, action = {}) => {
  let pages = [...state.exportBtnPage];
  if (action.type === actions.EXPORT_BUTTON_PAGE.ADD_PAGE_NAME) {
    if (!pages.includes(action.value)) pages.push(action.value);
  } else {
    pages = pages.filter((page) => page !== action.value);
  }
  switch (action.type) {
    case actions.EXPORT_BUTTON_PAGE.ADD_PAGE_NAME:
      return { ...state, exportBtnPage: pages };
    case actions.EXPORT_BUTTON_PAGE.REMOVE_PAGE_NAME:
      return { ...state, exportBtnPage: pages };
    default:
      return state;
  }
};
export default ExportBtnPages;
